import React from "react";
import { ArrowUpRight, Zap, ArrowDown } from "lucide-react";
import PulseCanvas from "@/components/vlyt/PulseCanvas";
import { VLYT } from "@/constants/testIds/vlyt";
import { Link } from "react-router-dom";

export default function Hero({ onOpenWaitlist }) {
  return (
    <section className="relative min-h-[100vh] pt-[68px] overflow-hidden grain">
      <PulseCanvas />

      {/* content overlay */}
      <div className="relative z-10 mx-auto max-w-[1440px] px-5 md:px-10 pt-16 md:pt-28 pb-24">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 text-eyebrow mb-8">
            <span className="h-1.5 w-1.5 rounded-full bg-lime auto-pulse-dot" />
            For Covenant University students
          </div>

          <h1
            data-testid={VLYT.hero.headline}
            className="text-display font-display leading-[0.98] max-w-[15ch]"
          >
            Certainty in{" "}
            <span className="lime-underline text-lime">Motion.</span>
          </h1>

          <p
            data-testid={VLYT.hero.subhead}
            className="mt-8 max-w-2xl text-[17px] md:text-[19px] text-[color:var(--vlyt-text)] leading-relaxed"
          >
            Guaranteed morning pickups. Walk-up rides at every campus stand. Fares stay with your
            driver.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <button
              type="button"
              onClick={onOpenWaitlist}
              data-testid={VLYT.hero.ctaPrimary}
              className="btn-lime"
            >
              <Zap size={16} strokeWidth={2.8} /> Join the waitlist
            </button>
            <Link to="/about" data-testid={VLYT.hero.ctaSecondary} className="btn-ghost">
              How it works <ArrowUpRight size={16} />
            </Link>
          </div>

          {/* stats mini row */}
          <div className="mt-16 grid grid-cols-3 max-w-2xl gap-6 md:gap-10">
            {[
              { k: "8 min", v: "avg. pickup" },
              { k: "0 SIM", v: "auth required" },
              { k: "8:00 AM", v: "guaranteed pickup" },
            ].map((s) => (
              <div key={s.k} className="border-l border-[color:var(--vlyt-border)] pl-4">
                <div className="text-h3 font-display text-lime">{s.k}</div>
                <div className="text-[13px] font-mono text-[color:var(--vlyt-muted)] uppercase tracking-wider">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* scroll hint */}
      <div
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-[color:var(--vlyt-muted)]"
        data-testid={VLYT.hero.scrollHint}
      >
        <span className="text-[11px] font-mono tracking-[0.32em] uppercase">Scroll</span>
        <ArrowDown size={16} className="animate-bounce text-lime" />
      </div>
    </section>
  );
}
